import { AccountType } from "@common/constants/domains/accounting/accounts";
import { ScopeInsertPosition } from "../draftOperations";
import { NestedEditorRow } from "./nestedRowTypes";

// An inline Add mints its draft rows on the click but writes nothing until the
// name lands: a group with no name cannot be addressed by path, and a create
// with a blank name is a 400. Until then the row is inert — nothing may name it
// as a neighbour, a drop target or an Add host.
export interface PendingAddTarget {
    draftId: string;
    entityId: number;
    parentGroupId: string | null;
    position: ScopeInsertPosition;
}

export interface PendingAddEntry {
    // One id per click, so two pending Adds in the same parent stay two rows.
    gestureId: string;
    kind: "account" | "group";
    accountType: AccountType;
    targets: PendingAddTarget[];
}

export const isRowPending = (
    row: NestedEditorRow,
    pendingDraftIds: ReadonlySet<string>,
): boolean =>
    row.accounts.some((account) => pendingDraftIds.has(account.id)) ||
    row.groups.some((group) => pendingDraftIds.has(group.id));
